function init() {
    var $elements = $(".arrow-border").not('[data-arrow-border-event=1]');
    $elements.each(function () {
        var elemento = $(this);
        elemento.attr('data-arrow-border-event', 1);
        elemento.parent().on('click', function() {
            elemento.toggleClass('open');
        });
    })
}
export default {
    init,
}


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/arrow-border.js